import {DiscountAttempt} from '@udemy-v2/api-shopping';
import {SOURCE_TYPE, DISCOUNT_STATUSES} from './constants';

export const isDiscountRemovable = (discount: DiscountAttempt) => {
    return (
        discount.status === DISCOUNT_STATUSES.APPLIED &&
        discount.source_type !== SOURCE_TYPE.UDEMY_COUPON
    );
};
